import { useCallback, useMemo } from 'react';
import { memoWithDisplayName } from '../../../helpers/memoWithDisplayName';
import { NestedCheckboxGroupDesktop } from '../../NestedCheckboxGroup';
import { prepareCheckboxGroupsChangeModel } from '../helpers/prepareCheckboxGroupsChangeModel';
import { prepareCheckboxGroupsItemChangeModelFactory } from '../helpers/prepareCheckboxGroupsItemChangeModelFactory';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var NestedCheckboxGroupsDesktop = memoWithDisplayName(function (props) {
  var behavior = props.behavior,
      groups = props.groups,
      _props$searchValue = props.searchValue,
      searchValue = _props$searchValue === void 0 ? '' : _props$searchValue,
      values = props.values,
      onNestedCheckboxClick = props.onNestedCheckboxClick,
      onTitleCheckboxClick = props.onTitleCheckboxClick,
      renderNestedCheckbox = props.renderNestedCheckbox,
      renderTitleCheckbox = props.renderTitleCheckbox;
  var valuesCollection = useMemo(function () {
    return new Set(values);
  }, [values]);
  var handleNestedCheckboxClick = useCallback(function (checkboxGroupItemChangeModel) {
    var checkboxGroupsItemChangeModel = prepareCheckboxGroupsItemChangeModelFactory(behavior)(groups, checkboxGroupItemChangeModel);
    onNestedCheckboxClick(checkboxGroupsItemChangeModel);
  }, [behavior, groups, onNestedCheckboxClick]);
  var handleTitleCheckboxClick = useCallback(function (checkboxGroupItemChangeModel) {
    var checkboxGroupsChangeModel = prepareCheckboxGroupsChangeModel(groups, checkboxGroupItemChangeModel);
    onTitleCheckboxClick(checkboxGroupsChangeModel);
  }, [groups, onTitleCheckboxClick]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: groups.map(function (group) {
      var withoutTitle = group.items.length === 1 || groups.length === 1;
      var isNestedCheckboxesOpen = withoutTitle || !!searchValue;
      return /*#__PURE__*/_jsx(NestedCheckboxGroupDesktop, {
        behavior: behavior,
        group: group,
        isNestedCheckboxesOpen: isNestedCheckboxesOpen,
        renderNestedCheckbox: renderNestedCheckbox,
        renderTitleCheckbox: renderTitleCheckbox,
        searchValue: searchValue,
        values: valuesCollection,
        withoutTitle: withoutTitle,
        onNestedCheckboxClick: handleNestedCheckboxClick,
        onTitleCheckboxClick: handleTitleCheckboxClick
      }, group.value);
    })
  });
}, 'NestedCheckboxGroupsDesktop');